module.exports = __webpack_public_path__ + "static/media/0001.8f8ed9ca.jpg";